<template>
	<div>
		<edit-page-gen :options="options" />
	</div>
</template>

<script>
import _ from 'lodash'
import EditPageGen from './EditPageGen.vue'
import axiosApiClient from '../api/axiosApiClient'
import { getLocations } from '@/api/locations-api'

const config = {
	options: {
		resource: 'clients',
		schemaModifier: async (schema, value) => {
			schema.properties.translations.items.properties.locale.valueInLegend = true
			schema.properties.translations.items.properties.logo.file = true
			const { id } = value
			const formtags = ['']
			// GET client specific forms
			let response = await axiosApiClient({
				url: `/forms?id=${id}_*&limit=200`
			})
			formtags.push(...response.data.map(i => i.tag))
			// GET common forms
			response = await axiosApiClient({
				url: `/forms?id=COMMON_*&limit=200`
			})
			formtags.push(...response.data.map(i => i.tag))
			schema.properties.attributes.properties.zapierUrl.items.properties.formTag.enum =
				_.uniq(formtags)
			// GET locations
			response = await getLocations()
			const locations = response.data.map(i => i.id)
			schema.properties.attributes.properties.zapierUrl.items.properties.location.enum =
				locations
			schema.properties.locations.items.enum = locations

			response = await axiosApiClient({ url: `/locales?limit=100` })
			const locales = response.data.map(i => i.id)
			schema.properties.translations.items.properties.locale.enum =
				locales

			const tagsResponse = await axiosApiClient({
				url: `/order-tag-keys?limit=100`
			})
			const tags = tagsResponse.data.map(t => t.id)
			if (tags.length > 0) {
				schema.properties.orderTags.items.properties.tagId.enum = tags
			} else {
				delete schema.properties.orderTags
			}
			const internalActions = [
				'DELETE_FORM_SUBMISSION',
				'CANCEL_REQUEST',
				'EDIT_REQUEST'
			]
			const actions =
				schema.properties.attributes.properties.zapierUrl.items
					.properties.action.enum
			schema.properties.attributes.properties.zapierUrl.items.properties.action.enum =
				actions.filter(i => !internalActions.includes(i))
			return schema
		}
	}
}

export default {
	name: 'ClientEdit',
	components: { EditPageGen },
	data: () => config
}
</script>
